import React from 'react';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import classNames from 'classnames';
import './index.scss';

const CardState = (props: any) => {

  const { children, data, apiGroup=[], style, className, singleError = false, changeData, ...restProps } = props || {};

  // 确保apiGroup是数组
  const isLoading = apiGroup?.some((key: string) => data[key]?.loading !== false);
  const isError = apiGroup.some((key: string) => data[key]?.errorMsg);

  const componentItem = (
    // 保证是jsx数组，而不是其他类型数组
    React.Children.map(children, (child: any) => React.cloneElement(
      child,
      {
        ...restProps,
        changeData,
        data,
        errorStyle: style,
        state: {}
      }
    ))
  );

  return (
    <Abnormal
      className={classNames("dbh-card-state",className)}
      isLoading={isLoading}
      isError={singleError ? false : isError}
      style={{ ...style, background: '#fff'}}
      component={componentItem}
    />
  );
};

export default CardState;
